import { getCatalogItem, getNavRoute } from './sidebarCatalog';
import { normalizePathname } from './privateRouteAccess';

const MY_SCHOOL_SETTINGS_PATH = '/my-school-settings';

/** Hub is allowed when the plan includes the hub link or any page it embeds. */
const MY_SCHOOL_SETTINGS_GATE_NAV_IDS = new Set([
  'item133',
  'item10',
  'item32',
  'item34',
  'item6',
  'item8',
  'item78',
  'item88',
  'item111',
  'item112',
  'item115',
  'item116',
  'item102',
]);

function isMySchoolSettingsAllowedByPlan(allowedNavIds) {
  return (allowedNavIds || []).some((id) => MY_SCHOOL_SETTINGS_GATE_NAV_IDS.has(String(id)));
}

/** Related routes allowed when a parent nav path is allowed (detail/edit flows). */
const PATH_ALIASES = [
  { prefix: '/add-student', also: ['/edit-student'] },
  { prefix: '/view-all-students', also: ['/view-student-profile', '/student-promotion', '/alumni'] },
  { prefix: '/fee-details-page', also: ['/collect-fees', '/fee-arrears'] },
  { prefix: '/fees-info', also: ['/fee-reminders'] },
  { prefix: '/add-plan', also: ['/action-plan'] },
  { prefix: '/add-complaint', also: [] },
  { prefix: '/school-admin-tickets', also: ['/ticket-info'] },
  { prefix: '/support-lead/tickets', also: ['/ticket-info'] },
];

const ALWAYS_ALLOWED = [
  '/profile',
  '/settings',
  '/learn-thrillion/home',
  '/ticket-info',
  '/knowledge-base',
];

function expandAllowedPaths(allowedNavIds) {
  const paths = new Set();
  for (const navId of allowedNavIds || []) {
    const item = getCatalogItem(navId);
    if (!item?.path || item.path === '__logout__') continue;
    const route = getNavRoute(item);
    const norm = normalizePathname(route.split('?')[0]);
    paths.add(norm);
    const alias = PATH_ALIASES.find((a) => a.prefix === norm);
    if (alias?.also) {
      alias.also.forEach((p) => paths.add(normalizePathname(p)));
    }
  }
  return paths;
}

/**
 * @param {string} pathname
 * @param {string[]} allowedNavIds - empty = not enforced at route layer
 * @param {boolean} planNavEnforced
 */
export function isPathAllowedByPlan(pathname, allowedNavIds, planNavEnforced) {
  if (!planNavEnforced || !allowedNavIds?.length) return true;
  const path = normalizePathname(pathname);
  if (path === MY_SCHOOL_SETTINGS_PATH && isMySchoolSettingsAllowedByPlan(allowedNavIds)) {
    return true;
  }
  if (ALWAYS_ALLOWED.some((p) => path === p || path.startsWith(`${p}/`))) {
    return true;
  }
  const allowed = expandAllowedPaths(allowedNavIds);
  for (const prefix of allowed) {
    if (path === prefix || path.startsWith(`${prefix}/`)) return true;
  }
  return false;
}

export function getPlanRedirectPath(allowedNavIds) {
  const item = getCatalogItem('item1');
  if (item?.path && item.path !== '__logout__') {
    return getNavRoute(item).split('?')[0];
  }
  const first = allowedNavIds?.[0];
  const meta = first ? getCatalogItem(first) : null;
  if (meta?.path && meta.path !== '__logout__') {
    return getNavRoute(meta).split('?')[0];
  }
  return '/dashboard';
}
